import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang';

const DAY_IN_SECONDS = 24 * 60 * 60;
const HOUR_IN_SECONDS = 60 * 60;
const MINUTE_IN_SECONDS = 60;
export const TIME_LEFT_WARNING_LIMIT = 4 * 60 * 60;

const ServerTimeLeft = ({ seconds }) => {
    const { t } = useTranslator();
    const ifValueNotZeroShowLabel = (label, value) =>
        value > 0 ? ' ' + t(label, { count: value }) : '';

    const getTimeLeftLabel = () => {
        if (seconds < MINUTE_IN_SECONDS) {
            return t('vip_less_than_1_min_left');
        }
        if (seconds < HOUR_IN_SECONDS) {
            const minutes = Math.floor(seconds / MINUTE_IN_SECONDS);
            return t('vip_minutes', { count: minutes });
        }

        if (seconds >= HOUR_IN_SECONDS && seconds < DAY_IN_SECONDS) {
            const hours = Math.floor(seconds / HOUR_IN_SECONDS);
            const minutes = Math.floor(
                Math.floor(seconds % HOUR_IN_SECONDS) / MINUTE_IN_SECONDS
            );
            return (
                t('vip_hours', { count: hours }) +
                ifValueNotZeroShowLabel('vip_minutes', minutes)
            );
        }

        const days = Math.floor(seconds / DAY_IN_SECONDS);
        const hours = Math.floor(
            Math.floor(seconds % DAY_IN_SECONDS) / HOUR_IN_SECONDS
        );

        return (
            t('vip_days', { count: days }) +
            ifValueNotZeroShowLabel('vip_hours', hours)
        );
    };

    return (
        <div
            className={
                seconds < TIME_LEFT_WARNING_LIMIT ? 'text-danger' : null
            }>
            {getTimeLeftLabel()}
        </div>
    );
};

ServerTimeLeft.propTypes = {
    seconds: PropTypes.number
};

export default ServerTimeLeft;
